import Vue from 'vue'
import App from './App'
import router from './router'
// import './assets/iconfont/iconfont.css';
//
// import { getUrl } from '@/utils/url'
import * as filters from './plugins/filters'
import store from '@/vuex/index'
import storage from '@/plugins/storage'
import ViewUI from 'view-design'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/container.scss'
import faviconUrl from '@/assets/images/favicon.png'
import { request, cancelRequest } from '../src/utils/httpRequest'
// 全局引入封装组件
import {InstallAll} from '@/components/global.js'
import '../xtxasyn.js'
Vue.use(InstallAll)
Vue.use(ElementUI)
Vue.use(ViewUI)
Vue.config.productionTip = false

function setFavicon () {
  let faviconLink = document.querySelector('link[rel="icon"]')
  if (!faviconLink) {
    faviconLink = document.createElement('link')
    faviconLink.setAttribute('rel', 'icon')
    document.head.appendChild(faviconLink)
  }
  faviconLink.setAttribute('type', 'image/png')
  faviconLink.setAttribute('href', faviconUrl)
}

setFavicon()

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title ? to.meta.title : '榆林水务集团电子采购平台'
  next()
})
// 后端接口返回的图片路径添加域名
Vue.filter('imgHost', function (value) {
  if (value) {
    let imgHost = window.fe.imgHost || '//testpic.sxylny.com/'
    const isLinkRe = /^((http:\/\/)|(https:\/\/)|(\/\/))/
    if (isLinkRe.test(value)) {
      return typeof value === 'string' ? value.replace(/\s/g, encodeURIComponent(' ')) : value
    } else {
      if (value[0] === '/') {
        return `${imgHost}${typeof value === 'string' ? value.replace(/\\s/g, encodeURIComponent(' ')) : value}`
      } else {
        if (imgHost[imgHost.length - 1] === '/') {
          return `${imgHost}${typeof value === 'string' ? value.replace(/\\s/g, encodeURIComponent(' ')) : value}`
        } else {
          return `${imgHost}/${typeof value === 'string' ? value.replace(/\\s/g, encodeURIComponent(' ')) : value}`
        }
      }
    }
  }
})
// router.afterEach(route => {
// })
Vue.prototype.linkTo = function (url) {
  if (url.substr(0, 1) === '/') { // 非外部链接，没有origin，只有路由地址
    if (router.mode === 'hash') {
      window.open(location.origin + '/#' + url, '_blank')
    } else {
      window.open(location.origin + url, '_blank')
    }
  } else { // 外部链接，完整的url地址
    window.open(url, '_blank')
  }
}
Vue.prototype.Cookies = storage
Vue.prototype.$http = request
Vue.prototype.$cancelRequest = cancelRequest
Vue.prototype.$store = store
Vue.prototype.$imghost = 'http://uatstaffpic.sunyur.com/'
/* eslint-disable no-new */

// ---------------
// const Loading = Vue.prototype.$loading
// const Message = Vue.prototype.$message
// 全局router
// const router = window.VueRouter
// export default function getData (promise, option) {
//   let optionDefault = {
//     authError: true, // 权限错误
//     showError: true, // 是否处理错误信息
//     tokeInvalidError: true, // token 无效错误
//     code: null, // 错误code 对应提示
//     loadingOptions: null // loading 配置
//   }
//   option = typeof option === 'object' ? Object.assign(optionDefault, option) : optionDefault
//   let {showError, code, loadingOptions, authError, tokeInvalidError} = option
//   const loading = loadingFn(loadingOptions)
//   return promise.then(res => {
//     const data = res.data
//     const currentPageRequest = data.currentPageRequest
//     // 如果不是同一个页面请求 不处理
//     if (!currentPageRequest) {
//       authError = false
//       showError = false
//     }
//     if (data.code === 'success') {
//       data.isOk = true
//     } else {
//       let handleAuthError = false // 是否处理过权限错误
//       // let jumpState = window.jumpState // 跳转状态
//       let vueInstantiation = window.vueInstantiation
//       if (authError) {
//         // 如果没有登录
//         console.log(data)
//         if (data.code === 'NO_LOGIN') {
//           if (data.loginSource === 'outer') {
//             window.location.href = getUrl(`/purchaser/tripartiteExternalLogin?syReturnUrl=${encodeURIComponent(window.location.href)}${window.fe.loginWay ? `&loginWay=${window.fe.loginWay}` : ''}`)
//           } else {
//             window.location.href = getUrl(`/purchaser/${window.fe.loginWay ? `?loginWay=${window.fe.loginWay}` : ''}#/member/login?url=${encodeURIComponent(window.location.href)}&isMall=true`)
//           }
//           handleAuthError = true
//           vueInstantiation.$store.commit('setUserInfo', { loginStatus: false })
//         } else if (data.code === 'NO_PERMISSION') {
//           handleAuthError = true
//           vueInstantiation.$router.push({ path: '/no-auth' })
//         }
//       }
//       if (tokeInvalidError) {
//         if (data.code === 'INVALID_TOKEN') {
//           // handleAuthError = true
//           // vueInstantiation.$router.push({ path: '/no-auth' })
//           window.location.reload()
//         }
//       }
//       if (data.code === 'NO_LOGIN' || data.code === 'NO_PERMISSION' || data.code === 'INVALID_TOKEN') {
//         showError = false
//       }
//       if (showError && !handleAuthError) {
//         const msg = (code && code[data.code] && code[data.code].message) ||
//           data.errorMessage || '网络异常请稍后重试'
//         Message.error(msg)
//       }
//       data.isOk = false
//     }
//     // 请求状态 请求发送成功 后端返回异常
//     data.requestState = true
//     loading.hide()
//     return data
//   }).catch(function (err) {
//     if (err && err.response) {
//       const status = {
//         400: { message: '请求错误' },
//         401: { message: '未授权，请登录' },
//         403: { message: '拒绝访问' },
//         404: { message: '请求地址出错:' },
//         408: { message: '请求超时' },
//         500: { message: '服务器内部错误' },
//         501: { message: '服务未实现' },
//         502: { message: '网关错误' },
//         503: { message: '服务不可用' },
//         504: { message: '网关超时' },
//         505: { message: 'HTTP版本不受支持' },
//         default: { message: '未知错误' }
//       }
//       const statusCode = status[err.response.status] || status.default
//       console.log(statusCode.message)
//     }
//     if (showError) {
//       Message({
//         message: (code && code['DEFAULT'] && code['DEFAULT'].message) || '网络异常请稍后重试',
//         type: 'error'
//       })
//     }
//     err.isOk = false
//     // 请求状态 请求未发送成功
//     err.requestFail = false
//     // 隐藏loading
//     loading.hide()
//     return err
//   })
// }

// function loadingFn (loadingOptions) {
//   // load 默认配置
//   const loadingOptionsDefault = {
//     text: '拼命加载中',
//     background: 'rgba(255, 255, 255, 0.8)',
//     spinner: 'el-icon-loading'
//   }
//   // 通过判断参数类型来区分是否合并参数 字符串：使用默认参数 对象：合并参数
//   const isLoadingOptions = typeof loadingOptions === 'object'
//   const loading = {
//     state: !!loadingOptions,
//     instance: null,
//     option: isLoadingOptions ? Object.assign(loadingOptionsDefault, loadingOptions) : loadingOptionsDefault,
//     hide: function () {
//       if (this.state) {
//         this.instance.close()
//       }
//     }
//   }
//   if (loading.state) {
//     loading.instance = Loading(loading.option)
//   }
//   return loading
// }
// export function isResponseOk (res) {
//   if (!res) {
//     Message({
//       message: '网络异常请稍后重试',
//       type: 'error'
//     })
//     return
//   }
//   if (!res.success) {
//     Message({
//       message: res.errorMessage,
//       type: 'error'
//     })
//     return
//   }
//   return true
// }

// -------------------
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 设置全局过滤器
Vue.prototype.$filter = {
  imgHost: function (value) {
    if (value) {
      let imgHost = window.fe.imgHost
      const isLinkRe = /^((http:\/\/)|(https:\/\/)|(\/\/))/
      if (isLinkRe.test(value)) {
        return typeof value === 'string' ? value.replace(/\s/g, encodeURIComponent(' ')) : value
      } else {
        if (value[0] === '/') {
          return `${imgHost}${typeof value === 'string' ? value.replace(/\\s/g, encodeURIComponent(' ')) : value}`
        } else {
          if (imgHost[imgHost.length - 1] === '/') {
            return `${imgHost}${typeof value === 'string' ? value.replace(/\\s/g, encodeURIComponent(' ')) : value}`
          } else {
            return `${imgHost}/${typeof value === 'string' ? value.replace(/\\s/g, encodeURIComponent(' ')) : value}`
          }
        }
      }
    }
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/main.js